import { render } from "./Access.vue?vue&type=template&id=a9727a46"
import script from "./Access.vue?vue&type=script&lang=ts"
export * from "./Access.vue?vue&type=script&lang=ts"
script.render = render

export default script